import { cva } from 'class-variance-authority'

export const inputVariants = cva(
  'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input w-full min-w-0 rounded-md border bg-transparent shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
  {
    variants: {
      size: {
        default: 'h-9 px-3 py-1 text-base md:text-sm',
        sm: 'h-8 px-3 py-1 text-xs',
        xs: 'h-8 px-2 py-1 text-xs',
        compact:
          'h-9 w-[80px] sm:w-[100px] px-3 pr-8 text-xs text-muted-foreground bg-card border-border flex-shrink-0',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
)
